import { Select } from "@material-ui/core";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Button,
  Box,
  IconButton,
  MenuItem,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionActions,
  Tooltip,
  ListItemText,
} from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import Loading from "../../components/Loading/Loading";
import { DataGrid } from "@mui/x-data-grid";
import {
  //CreateQuotation,
  AddBulk,
  GetAllNonStdFeatures,
  GetAllQuotationList,
  GetCompetitorList,
  GetDetailsOfMLFB,
  GetOfficeList,
  getQuotationRefNo,
  GetQuotations,
  DeleteQuotation,
  GetSelectedZcodes,
} from "../../redux/API/api_quotation";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  getPreviewDrawing,
  drawingUpload,
} from "../../redux/API/api_uploadDrawing";
import {
  getCountriesList,
  getDBTypeListBasedOnDbSeries,
  getMLFBSeriesList,
  getNoOfWaysList1,
  getNoOfWaysList2,
  getVariantsList,
} from "../../redux/API/api_standardMLFB";
import SnackbarCustom from "../../components/Snackbar/Snackbar";
import UploadDrawingDialog from "./Upload_Drawing_Dialog";
import Checkbox from "@mui/material/Checkbox";
//import IconButton from '@mui/material/IconButton';
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DownloadIcon from "@mui/icons-material/Download";
import * as XLSX from "xlsx";

const UpdateUploadDrawing = React.memo(({ open, onClose, editQuotation }) => {
  const columns = [
    {
      field: "upload Drawing",
      headerName: "Upload Drawing",
      //flex: 0.5,
      sortable: false,
      width: 120,
      
      renderCell: (params) => (
        <IconButton
          onClick={() => handleDrawing(params.row)}
          title="upload Drawing"
        >
          <CloudUploadIcon style={{ color: "#1976d2" }} />
        </IconButton>
      ),
    },
    {
      field: "standard MLFB",
      headerName: "Standard MLFB",
     // flex: 0.5,
      sortable: false,
      width: 120,
      //gap: "20px",

      renderCell: (params) => (
        <div>
          <span
            style={{ cursor: "pointer", color: "blue" }}
            onClick={() => setQuotationData(params.row)}
          >
            {params.row.mlfbName}
          </span>
        </div>
      ),
    },
    { field: "selectedZcodes", headerName: "Z Codes", width: 250 },
    { field: "db", headerName: "DB", width: 200 },
    { field: "quantity", headerName: "Quanity", width: 200 },
    { field: "dbTypeName", headerName: "Type of DB", width: 200 },
    { field: "noOfWaysName", headerName: "No of Ways", width: 200 },
    { field: "variantName", headerName: "Varient", width: 200 },
    { field: "orientation", headerName: "Orientation", width: 200 },
    { field: "countryName", headerName: "Country oF Origin", width: 200 },
    { field: "unitNetPrice", headerName: "Unit List Price", width: 200 },
    { field: "totalListPrice", headerName: "Total Price", width: 200 },
    { field: "quotationRefNo", headerName: "Quotation Ref No", width: 200 },
    { field: "drawing", headerName: "Drawing", width: 200 },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.5,
      sortable: false,
      width: "20px",
      gap: "20px",

      renderCell: (params) => (
        <div>
          <IconButton onClick={() => handleDelete(params.row)}>
            <DeleteIcon />
          </IconButton>
        </div>
      ),
    },
  ];

  const [loaderUploading, setUploading] = useState(false);
  const [error, setError] = useState("");
  const userdetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  const [SelectedZCodes, setSelectedZCodes] = useState("");
  const [loader, setLoader] = useState(false);
  const siteToken = useSelector((state) => state.saveTokenReducer);
  const azureToken = useSelector((state) => state.saveAzureTokenReducer);
  const UID = useSelector((state) => state.saveUserIdReducer);
  const [isLoader, setIsLoader] = useState(false);
  const [rows, setRows] = useState();
  const [tabIndex, setTabIndex] = useState(0);
  const [isdbSelected, setIsdbSelected] = useState(false);
  const [expanded, setExpanded] = useState(null);
  const [features, setFeatures] = useState([]);
  const [feature, setFeature] = useState({});
  const [alertType, setAlertType] = useState("");
  const [opened, setOpen] = useState(false);
  const [opend, setOpend] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedFeatures, setSelectedFeatures] = useState([]);
  const [zcodes, setZodes] = useState([]);
  const [quatationDetailId,setQuotationDetailId] = useState("");

  const [formData, setFormData] = useState({
    philosNo: "",
    competitorName: "",
    salesOffice: "",
    orderFinalizationDate: "",
    expectedBusinessVolume: "",
    personName: "",
    quotationRefNo: "",
    projectName: "",
    customerName: "",
    industry: "",
    role: "",
    ifaNumber: "",
    endCustomerDetails: "",

    comment: "",

    dbseriesName: "",
    dbTypeName: "",
    horVertical: "",
    varient: "",
    contryOfOrigin: "",
    noOfWays: "",

    MLFBName: "",
    mrp: "",
    UnitNetPrice: "",
    Quantity: "",
    zopt: "",
    totalNetPrice: "",

    QuotationDetailId: 0,

    NoOfKnockout_Bottom: "",
    NoOfKnockout: "",
    quotationId: "",
    quotationStatus: "",
  });

  const [dropdownData, setDropdownData] = useState({
    competitors: [],
    salesOffices: [],
    dbSeriesList: [],
    varientList: [],
    countryList: [],
    horVerticalList: [],
    dbTypeList: [],
    noWaysList: [],
  });

  useEffect(() => {
    // fetch dd data
    //handleReset();
    const fetchDropdownData = async () => {
      setLoader(true);
      try {
        const quotrefNoResp = await getQuotationRefNo(
          siteToken,
          azureToken.token,
          UID.id,
          userdetails.userEmail,
          userdetails.gid,
          userdetails.roleName,
          userdetails.roleId
        );

        const competitorResponce = await GetCompetitorList(
          siteToken,
          azureToken.token,
          UID.id,
          userdetails.userEmail,
          userdetails.gid,
          userdetails.roleName,
          userdetails.roleId,
          0
        );

        const salesOfficeResponce = await GetOfficeList(
          siteToken,
          azureToken.token,
          UID.id,
          userdetails.userEmail,
          userdetails.gid,
          userdetails.roleName,
          userdetails.roleId,
          0
        );

        const DbSeriesListResponce = await getMLFBSeriesList(
          siteToken,
          azureToken.token,
          UID.id,
          userdetails.userEmail,
          userdetails.gid,
          userdetails.roleName,
          userdetails.roleId
        );

        const VariantListResponce = await getVariantsList(
          siteToken,
          azureToken.token,
          UID.id,
          userdetails.userEmail,
          userdetails.gid,
          userdetails.roleName,
          userdetails.roleId
        );

        const countryListResPonce = await getCountriesList(
          siteToken,
          azureToken.token,
          UID.id,
          userdetails.userEmail,
          userdetails.gid,
          userdetails.roleName,
          userdetails.roleId
        );

        const horVerticalList = [
          { id: 1, name: "Vertical" },
          { id: 2, name: "Horizontal" },
        ];

        const competitors = competitorResponce.objResult;
        const salesOffices = salesOfficeResponce.objResult;
        const dbSeriesList = DbSeriesListResponce;
        const varientList = VariantListResponce;
        const countryList = countryListResPonce;

        setDropdownData({
          competitors,
          salesOffices,
          dbSeriesList,
          varientList,
          countryList,
          horVerticalList,
        });
        setFormData((prev) => ({
          ...prev,
          quotationRefNo: quotrefNoResp,
        }));

        if (editQuotation.editQuotation?.quotationId) {
          getQuotationList(editQuotation.editQuotation.quotationId);
        }
        setLoader(false);
      } catch (error) {
        console.log("error fetching data", error);
        setLoader(false);
      }
    };
    fetchDropdownData();
  }, [editQuotation]);

  const handleChange = (e) => {
    try {
      e.target.value = JSON.parse(e.target.value);
    } catch {
      e.target.value = e.target.value;
    }
    setIsdbSelected(true);
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError("");
    let mlfb = "";
    if (e.target.name == "dbseriesName") {
      getdbType(e.target.value);
    }

    if (e.target.name == "Quantity") {
      getDetailsOfMlfb("", e.target.value.Quantity);
    }

    // if (e.target.name == 'dbseriesName' && e.target.value.dbSeriesName != '8GB0'){
    //     getNofWaysList('dbseriesName', e.target.value)
    // }

    if (e.target.name == "dbTypeName") {
      if (e.target.value.dbTypeName.includes("5")) {
        mlfb =
          formData.dbseriesName?.dbSeriesName + e.target.value.dbTypeName[0];
      } else {
        mlfb =
          formData.dbseriesName?.dbSeriesName +
          e.target.value.dbTypeName[0] +
          "RC";
      }

      getNofWaysList("dbTypeName", e.target.value);
      getNonStdFeatures(e.target.value.dbTypeID);
    }

    if (e.target.name == "horVertical") {
      mlfb =
        formData.dbseriesName?.dbSeriesName +
        formData.dbTypeName?.dbTypeName[0] +
        e.target.value.horVertical[0] +
        "RC";
    }

    if (e.target.name == "varient") {
      mlfb =
        formData.dbseriesName?.dbSeriesName +
        formData.dbTypeName?.dbTypeName[0] +
        e.target.value.variant[0] +
        e.target.value.variant[1] +
        "RC";
    }

    console.log("fomr", formData);
    if (e.target.name == "noOfWays") {
      if (
        formData.horVertical != "" &&
        formData.horVertical?.horiVerticalName != ""
      ) {
        mlfb =
          formData.dbseriesName?.dbSeriesName +
          formData.dbTypeName?.dbTypeName[0] +
          formData.horiVerticalName?.horiVerticalName[0] +
          e.target.value.noOfWaysName[0] +
          e.target.value.noOfWaysName[1] +
          "RC";
      } else if (
        formData.varient != "" &&
        formData.varient?.variantName != ""
      ) {
        mlfb =
          formData.dbseriesName?.dbSeriesName +
          formData.dbTypeName?.dbTypeName[0] +
          formData.varient?.variantName[0] +
          formData.varient?.variantName[1] +
          "RC" +
          e.target.value.noOfWaysName[0] +
          e.target.value.noOfWaysName[1];
      } else {
        mlfb =
          formData.dbseriesName?.dbSeriesName +
          formData.dbTypeName?.dbTypeName[0] +
          e.target.value.noOfWaysName[0] +
          e.target.value.noOfWaysName[1] +
          "RC";
      }
    }

    if (mlfb != "") {
      setFormData((prev) => ({
        ...prev,
        MLFBName: mlfb,
      }));
      getDetailsOfMlfb(mlfb, 0);
    }
  };

  const getdbType = async (e) => {
    const dbTypeListResp = await getDBTypeListBasedOnDbSeries(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      e.dbSeriesName,
      e.dbSeriesId
    );
    const dbTypeList = dbTypeListResp;
    setDropdownData((prev) => ({
      ...prev,
      dbTypeList,
    }));

    return dbTypeList;
  };

  const getNofWaysList = async (type, e) => {
    if (formData.dbseriesName?.dbSeriesName == "8GB0") {
      const noofWaysListResp = await getNoOfWaysList1(
        siteToken,
        azureToken.token,
        UID.id,
        userdetails.userEmail,
        userdetails.gid,
        userdetails.roleName,
        userdetails.roleId,
        formData.dbseriesName?.dbSeriesId
      );
      const noWaysList = noofWaysListResp;
      setDropdownData((prev) => ({
        ...prev,
        noWaysList,
      }));
      return noWaysList;
    } else {
      const noofWaysListResp = await getNoOfWaysList2(
        siteToken,
        azureToken.token,
        UID.id,
        userdetails.userEmail,
        userdetails.gid,
        userdetails.roleName,
        userdetails.roleId,
        e.dbTypeID
      );
      const noWaysList = noofWaysListResp;
      setDropdownData((prev) => ({
        ...prev,
        noWaysList,
      }));
      return noWaysList;
    }
  };

  const getDetailsOfMlfb = async (mlfb, qty) => {
    try {
      let input = {};
      input.SelectedZCodes = "";
      if (qty != 0) {
        input.Quantity = qty;
      } else {
        input.Quantity = formData.qty ? formData.qty : qty;
      }

      if (mlfb != "") {
        input.MLFBName = mlfb;
      } else {
        input.MLFBName = formData.MLFBName;
      }
      const mlfbDetailsResp = await GetDetailsOfMLFB(
        siteToken,
        azureToken.token,
        UID.id,
        userdetails.userEmail,
        userdetails.gid,
        userdetails.roleName,
        userdetails.roleId,
        input
      );

      console.log("mlfbDetailsResp", mlfbDetailsResp);
      setFormData((prev) => ({
        ...prev,

        mrp: mlfbDetailsResp.mrp,
        UnitNetPrice: mlfbDetailsResp.unitNetPrice,
        zopt: "",
        totalNetPrice: mlfbDetailsResp.totalNetPrice,
      }));
    } catch (error) {
      console.log("eror", error);
    }
  };

  const getNonStdFeatures = async (dbtypeId, dbSeriesID) => {
    setLoader(true);
    const NonStandardfeatures = await GetAllNonStdFeatures(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      "",
      dbSeriesID,
      dbtypeId
    );
    console.log("NonStandardfeatures", NonStandardfeatures);
    let zid = [];
    if (editQuotation.editQuotation?.quotationId) {
      for (let i = 0; i < NonStandardfeatures.length; i++) {
        for (let j = 0; j < NonStandardfeatures[i].subcategories.length; j++) {
          for (
            let k = 0;
            k <
            NonStandardfeatures[i].subcategories[j].nonstandardFeature.length;
            k++
          ) {
            if (
              ZCodess.includes(
                NonStandardfeatures[i].subcategories[j].nonstandardFeature[k]
                  .zCode
              )
            ) {
              zid.push(
                NonStandardfeatures[i].subcategories[j].nonstandardFeature[k].id
              );
            }
          }
        }
      }
    }
    console.log("zid", zid);
    setZodes(zid);
    setLoader(false);
    setFeatures(NonStandardfeatures);
  };

  

  // getting user list
  function getQuotationList(quotationId) {
     setLoader(true);
     GetQuotations(
       siteToken,
       azureToken.token,
       UID.id,
       userdetails.userEmail,
       userdetails.gid,
       userdetails.roleName,
       userdetails.roleId,
       quotationId,
       formData.QuotationDetailId ? formData.QuotationDetailId:0
     )
       .then((response) => {
         setRows(
           response.quotationDetails.map((item, i) => ({
             id: i + 1,
             quotationRefNo: response.quotationRefNo,
 
             ...item,
           }))
         );
         console.log("rows", rows);
         const office = dropdownData.salesOffices.find(
           (opt) => opt.key == response.officeId
         );
         const comp = dropdownData.competitors.find(
           (opt) => opt.key == response.competitorId
         );
         setFormData((prev) => ({
           ...prev,
           competitorName: comp,
           salesOffice: office,
           orderFinalizationDate: response.orderFinalizationDate,
           expectedBusinessVolume: response.expectedBusinessVolume,
           personName: response.personName,
           quotationRefNo: response.quotationRefNo,
           projectName: response.projectName,
           customerName: response.customerName,
           industry: response.industry,
           role: response.role,
           endCustomerDetails: response.endCustomerDetails,
           quotationId: response.quotationId,
           quotationStatus: response.quotationStatus,
         }));
 
         setLoader(false);
       })
       .catch((error) => {
         console.log("Error: " + error, "error");
         setLoader(false);
       });
   }

  const handleChangefeature = async (e, options, isMultiselect) => {
    console.log("ffeature", e, options);
    let selectedCode = "";
    if (isMultiselect) {
      selectedCode = e.target.value[e.target.value.length - 1];
    } else {
      selectedCode = e.target.value;
    }

    const selectedId = options.find((x) => x.zCode == selectedCode);
    if (!selectedId) return;

    if (selectedCode) {
      if (isMultiselect) {
        const isAlreadySelected = selectedFeatures.includes(selectedCode);
        if (isAlreadySelected) {
          const updated = selectedFeatures.filter((x) => x !== selectedCode);
          setSelectedFeatures(updated);
        } else {
          const zCodeObj = [...selectedFeatures, selectedId.zCode];
          const zObj = [...new Set(zCodeObj)];
          setSelectedFeatures(zObj);
        }
      } else {
        const zCodeObj = [...selectedFeatures, selectedId.zCode];
        const zObj = [...new Set(zCodeObj)];
        setSelectedFeatures(zObj);
      }

      const zIdObj = [...zcodes, selectedId.id];
      const zidobj = [...new Set(zIdObj)];
      setZodes(zidobj);
      setLoader(true);
      await getZcode_and_Id(zidobj, false);
    }
  };

  const toggleAccordion = (index) => {
    setExpanded(expanded === index ? null : index);
  };
  const handleClose = (e) => {
    setOpend(false);
  };
  const handleDelete = (val) => {
    console.log("val", val);
    DeleteQuotation(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      val.quotationDetailID,
      formData.quotationId
    )
      .then((response) => {
        if (response.response) {
          handleSnackOpen(response.responseMsg, "success");
          setLoader(false);
          getQuotationList(formData.quotationId);
        } else {
          handleSnackOpen(response.responseMsg, "error");
          setLoader(false);
        }
      })
      .catch((error) => {
        handleSnackOpen("Exception : " + error, "error");
        setLoader(false);
      });
  };

  const getZcode_and_Id = (zidobj, bool) => {
    GetSelectedZcodes(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      zidobj,
      bool
    )
      .then((response) => {
        if (response) {
          setLoader(false);
          setSelectedZCodes(response);
        } else {
          setLoader(false);
          handleSnackOpen(response, "error");
        }
      })
      .catch((error) => {
        handleSnackOpen("Exception : " + error, "error");
        setLoader(false);
      });
  };

  let ZCodess = [];
  const setQuotationData = async (quotation) => {
    console.log("quotation", quotation);
    const dbser = dropdownData.dbSeriesList.find(
      (opt) => opt.dbSeriesId == quotation.dbSeriesID
    );
    const dbList = await getdbType(dbser);

    const dbtype = dbList.find((opt) => opt.dbTypeID == quotation.dbTypeID);
    const contr = dropdownData.countryList.find(
      (opt) => opt.countryId == quotation.countryID
    );
    const varie = dropdownData.varientList.find(
      (opt) => opt.variantId == quotation.variantID
    );
    const ori = dropdownData.horVerticalList.find(
      (opt) => opt.name == quotation.orientation
    );

    setFormData((prev) => ({
      ...prev,
      comment: quotation.comment,
      dbseriesName: dbser,
      dbTypeName: dbtype,
      varient: varie,
      contryOfOrigin: contr,
      //  noOfWays: noway,
      horiVerticalName: ori,
      MLFBName: quotation.mlfbName,
      mrp: quotation.mrp,
      UnitNetPrice: quotation.unitNetPrice,
      Quantity: quotation.quantity,
      zopt: quotation.zCodePrice,
      totalNetPrice: quotation.totalNetPrice,
      QuotationDetailId: quotation.quotationDetailID,
      NoOfKnockout: quotation.NoOfKnockout,
      NoOfKnockout_Bottom: quotation.NoOfKnockout_Bottom,
    }));

    const nList = await getNofWaysList("", dbtype);
    setSelectedZCodes(quotation.selectedZcodes);
    const zcodes = quotation.selectedZcodes.split("+");
    ZCodess = zcodes;
    setSelectedFeatures(zcodes);
    if (zcodes && zcodes.length > 0) {
      getNonStdFeatures(dbtype.dbTypeID, dbser.dbSeriesId);
    }

    const noway = nList.find((opt) => opt.noOfWaysId == quotation.noOfWaysID);
    if (quotation.noOfWaysID) {
      setIsdbSelected(true);
    }
    setFormData((prev) => ({
      ...prev,
      noOfWays: noway,
    }));
  };

  const addBulk = () => {
    setLoader(true);
    let input = {};

    input.QuotationRefNo = formData.quotationRefNo;

    input.PhilosNo = formData.philosNo;

    input.CompetitorId = Number(formData.competitorName.key);

    input.officeId = Number(formData.salesOffice.key);

    input.ExpectedBusinessVolume = Number(formData.expectedBusinessVolume);

    input.EndCustomerDetails = formData.endCustomerDetails;

    input.CreatedBy = userdetails.userId;

    input.OrderFinalizationDate = formData.orderFinalizationDate;

    input.zcodelist = features;

    input.QuotationDetailId = formData.QuotationDetailId;

    input.DBSeriesID = formData.dbseriesName.dbSeriesId;

    input.DBTypeID = formData.dbTypeName.dbTypeID;

    input.NoOfWaysID = formData.noOfWays.noOfWaysId;

    input.VariantID = formData.varient.variantId

    input.SelectedZCodes = SelectedZCodes;

    input.UnitNetPrice = formData.UnitNetPrice;

    input.TotalNetPrice = formData.totalNetPrice;

    input.MRP = formData.mrp;

    if (formData.NoOfKnockout != "") {
      input.NoOfKnockout = formData.NoOfKnockout;
    } else {
      input.NoOfKnockout = 0;
    }
    if (formData.NoOfKnockout_Bottom != "") {
      input.NoOfKnockout_Bottom = formData.NoOfKnockout_Bottom;
    } else {
      input.NoOfKnockout_Bottom = 0;
    }

    input.NoOfKnockout_Bottom = formData.NoOfKnockout_Bottom;

    input.MLFBName = formData.MLFBName;

    input.ProjectName = formData.projectName;
    input.CustomerName = formData.customerName;
    input.Industry = formData.industry;
    input.Role = formData.role;
    input.IFANumber = formData.ifaNumber;
    input.loggedInuserId = userdetails.userId;
    const bulk = formData.bulk;

    AddBulk(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      input,
      bulk
    )
      .then((response) => {
        if (response.response) {
          handleSnackOpen(response.responseMsg, "success");
          setLoader(false);
          getQuotationList(editQuotation.editQuotation.quotationId);
        } else {
          handleSnackOpen(response.responseMsg, "error");
          setLoader(false);
        }
      })
      .catch((error) => {
        handleSnackOpen("Exception : " + error, "error");
        setLoader(false);
      });
  };

  const exportToExcel = () => {
    let ExcelData = [];
    for (let i = 0; i < rows.length; i++) {
      let input = {};
      input.SrNo = i + 1;
      input.MlfbName = rows[i].mlfbName;
      input.DBType = rows[i].db;
      input.Quantity = rows[i].quantity;
      input.DbTypeName = rows[i].dbTypeName;
      input.NoOfWaysName = rows[i].noOfWaysName;
      input.variantName = rows[i].variantName;
      input.Orientation = rows[i].orientation;
      input.CountryName = rows[i].countryName;
      input.UnitNetPrice = rows[i].unitNetPrice;
      input.TotalListPrice = rows[i].totalListPrice;
      input.QuotationRefNo = rows[i].quotationRefNo;
      input.Drawing = rows[i].drawing;
      ExcelData.push(input);
    }
    const worksheet = XLSX.utils.json_to_sheet(ExcelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Upload Drawing");
    XLSX.writeFile(workbook, "UploadDrawing.xlsx");
  };

  const commonInputStyle = {
    width: "700px",
    padding: "7px",

    "& .MuiInputBase-root": {
      fontSize: "14px",
      height: "50px",
    },
  };

  const handleSnackOpen = (text, type) => {
    setSnackMessage(text);
    setAlertType(type);
    setOpend(true);
  };

  const viewDrawing = () => {
    setLoader(true);
    getPreviewDrawing(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      quatationDetailId.quotationDetailID
    )
      .then((response) => {
        setLoader(false);
        const pdfUrl = response?.result || response;
        console.log("pdfurl", pdfUrl);
        pdfUrl
          ? window.open(pdfUrl, "_blank")
          : handleSnackOpen("Error while downloading view drawing.", "error");
      })
      .catch((error) => {
        setLoader(false);
        handleSnackOpen("Error while downloading view drawing.", "error");
      });
  };

  const handleDrawing = useCallback((rowData) => {
    console.log('rowData',rowData);
    setQuotationDetailId(rowData);

    setOpenDialog(true);
  }, []);

  const onUploadDrawing = (data) => {
    setOpenDialog(false);
    setLoader(true);
    handleUploadDrawing(data);
  };

  function handleUploadDrawing(selectedFile) {
    setLoader(true);
    console.log('quatationDetailId',quatationDetailId)
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append(
      "QuotationDetailsID",
      quatationDetailId.quotationDetailID
    );
    drawingUpload(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      formData
    )
      .then((response) => {
        console.log(response);
        if (response.response) {
          setLoader(false);
          handleSnackOpen(response.responseMsg, "success");
          getQuotationList(editQuotation.editQuotation.quotationId);
        } else {
          setLoader(false);

          handleSnackOpen(
            response.responseMsgs && response.responseMsgs.length > 0
              ? response.responseMsgs
              : response.responseMsg
          );
        }
      })
      .catch((error) => {
        setLoader(false);

        handleSnackOpen("Exception in upload");
      });
  }

  return (
    <div>
      <Dialog open={open} onClose={onClose} fullScreen>
        <DialogTitle sx={{ fontWeight: "bold", textAlign: "left" }}>
          {editQuotation?.editQuotation ? "Upload Drawing" : " "}
          <IconButton
            onClick={onClose}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <Tabs
          value={tabIndex}
          onChange={(e, newValue) => setTabIndex(newValue)}
          indicatorColor="primary"
          textColor="primary"
          fontSize="14px"
          variant="fullWidth"
          sx={{
            "& .MuiTab-root": {
              width: "50%",
            },
            backgroundColor: tabIndex === 0 ? "#f0f0f0" : "transparent",
            borderRadius: "4px",
            transition: "background-color 0.2s ease-in-out",
          }}
        >
          <Tab
            label="offer Details"
            sx={{
              backgroundColor: tabIndex === 0 ? "#f0f0f0" : "transparent",
              fontWeight: tabIndex === 0 ? "bold" : "normal",
              //width:'50%'
            }}
          />
          <Tab
            label="order Distribution Board"
            sx={{
              backgroundColor: tabIndex === 1 ? "#f0f0f0" : "transparent",
              fontWeight: tabIndex === 1 ? "bold" : "normal",
              // width:'50%'
            }}
          />
        </Tabs>

        <DialogContent>
          {tabIndex === 0 && (
            <div  style={{
              marginTop: "20px",
              pointerEvents: editQuotation.editQuotation
                ? "none"
                : "auto",
              opacity: editQuotation.editQuotation ? 0.5 : 1,
            }}>
              <Stack direction="row" spacing={2} sx={{ padding: "10px" }}>
                <Box flex={1}>
                  <Box
                    sx={{
                      border: "1px solid #ccc",
                      padding: "10px",
                      borderRadius: "4px",
                    }}
                  >
                    <TextField
                      fullWidth
                      variant="filled"
                      label={
                        <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                          {" "}
                          Sie-Sales No/ IFA No{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="philosNo"
                      style={{ marginLeft: "0px" }}
                      value={formData.philosNo}
                      onChange={handleChange}
                      sx={commonInputStyle}
                    />

                    <FormControl size="small" sx={commonInputStyle}>
                      <InputLabel>
                        {
                          <span
                            style={{ fontSize: "0.90rem", fontWeight: 400 }}
                          >
                            Competitor Name
                            <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                      </InputLabel>

                      <Select
                        varient="filled"
                        name="competitorName"
                        value={
                          formData.competitorName
                            ? JSON.stringify(formData.competitorName)
                            : ""
                        }
                        onChange={handleChange}
                      >
                        {dropdownData.competitors.map((comp) => (
                          <MenuItem key={comp.key} value={JSON.stringify(comp)}>
                            {comp.value}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl size="small" sx={commonInputStyle}>
                      <InputLabel>
                        {
                          <span
                            style={{ fontSize: "0.90rem", fontWeight: 400 }}
                          >
                            Sales Office<span style={{ color: "red" }}>*</span>
                          </span>
                        }
                      </InputLabel>
                      <Select
                        name="salesOffice"
                        variant="filled"
                        value={
                          formData.salesOffice
                            ? JSON.stringify(formData.salesOffice)
                            : ""
                        }
                        onChange={handleChange}
                      >
                        {dropdownData.salesOffices.map((office) => (
                          <MenuItem
                            key={office.key}
                            value={JSON.stringify(office)}
                          >
                            {office.value}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <TextField
                      fullWidth
                      variant="filled"
                      label={
                        <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                          Order Finalisation Date{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      type="date"
                      name="orderFinalizationDate"
                      value={formData.orderFinalizationDate.split("T")[0] || ""}
                      onChange={handleChange}
                      margin="normal"
                      size="small"
                      sx={commonInputStyle}
                    />

                    <TextField
                      fullWidth
                      variant="filled"
                      label={
                        <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                          Expected Business Volume{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="expectedBusinessVolume"
                      type="number"
                      value={formData.expectedBusinessVolume}
                      onChange={handleChange}
                      sx={commonInputStyle}
                    />
                  </Box>
                </Box>

                <Box flex={1}>
                  <Box
                    sx={{
                      border: "1px solid #ccc",
                      padding: "10px",
                      borderRadius: "4px",
                    }}
                  >
                    <TextField
                      fullWidth
                      variant="filled"
                      label={
                        <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                          Name of the Person
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="personName"
                      value={formData.personName}
                      onChange={handleChange}
                      sx={commonInputStyle}
                    />

                    <TextField
                      fullWidth
                      variant="filled"
                      label={
                        <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                          Quotation Ref No{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="quotationRefNo"
                      value={formData.quotationRefNo}
                      onChange={handleChange}
                      sx={commonInputStyle}
                    />

                    <TextField
                      fullWidth
                      variant="filled"
                      label={
                        <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                          Project Name <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="projectName"
                      value={formData.projectName}
                      onChange={handleChange}
                      sx={commonInputStyle}
                    />

                    <TextField
                      fullWidth
                      variant="filled"
                      label={
                        <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                          Customer Name <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="customerName"
                      value={formData.customerName}
                      onChange={handleChange}
                      sx={commonInputStyle}
                    />

                    <TextField
                      fullWidth
                      variant="filled"
                      label={
                        <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                          Industry <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="industry"
                      value={formData.industry}
                      onChange={handleChange}
                      sx={commonInputStyle}
                    />

                    <TextField
                      fullWidth
                      variant="filled"
                      label={
                        <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                          role<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="role"
                      value={formData.role}
                      onChange={handleChange}
                      sx={commonInputStyle}
                    />

                    <TextField
                      fullWidth
                      variant="filled"
                      label={
                        <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                          IFA Number<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="ifaNumber"
                      value={formData.ifaNumber}
                      onChange={handleChange}
                      sx={commonInputStyle}
                    />

                    <TextField
                      fullWidth
                      variant="filled"
                      label={
                        <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                          End Customer Details{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="endCustomerDetails"
                      value={formData.endCustomerDetails}
                      onChange={handleChange}
                      sx={commonInputStyle}
                    />
                  </Box>
                </Box>
              </Stack>
            </div>
          )}

          {tabIndex === 1 && (
            <Stack direction="row" spacing={2} sx={{ padding: "10px" }}>
              <Box flex={1}>
                <div  style={{
                    marginTop: "20px",
                    pointerEvents: editQuotation.editQuotation
                      ? "none"
                      : "auto",
                    opacity: editQuotation.editQuotation ? 0.5 : 1,
                  }}>
                <Box
                  sx={{
                    border: "1px solid #ccc",
                    padding: "10px",
                    borderRadius: "4px",
                  }}
                >
                  <Typography variant="subtitle1">
                    {
                      <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                        {" "}
                        DB Technical Specification
                      </span>
                    }
                  </Typography>
                  <FormControl size="small" sx={commonInputStyle}>
                    <InputLabel>
                      {
                        <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                          DB Series<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                    </InputLabel>

                    <Select
                      name="dbseriesName"
                      variant="filled"
                      value={
                        formData.dbseriesName
                          ? JSON.stringify(formData.dbseriesName)
                          : ""
                      }
                      onChange={handleChange}
                    >
                      {dropdownData.dbSeriesList?.map((dbseries) => (
                        <MenuItem
                          key={dbseries.dbSeriesId}
                          value={JSON.stringify(dbseries)}
                        >
                          {dbseries.dbSeriesName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl size="small" sx={commonInputStyle}>
                    <InputLabel>
                      {
                        <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                          DB Type<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                    </InputLabel>
                    <Select
                      name="dbTypeName"
                      variant="filled"
                      value={
                        formData.dbTypeName
                          ? JSON.stringify(formData.dbTypeName)
                          : ""
                      }
                      onChange={handleChange}
                    >
                      {dropdownData.dbTypeList?.map((dbtype) => (
                        <MenuItem
                          key={dbtype.dbTypeID}
                          value={JSON.stringify(dbtype)}
                        >
                          {dbtype.dbTypeName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {formData.dbseriesName?.dbSeriesName == "8GB0" &&
                    formData.dbTypeName?.dbTypeName == "4-TPN" && (
                      <FormControl size="small" sx={commonInputStyle}>
                        <InputLabel>
                          {
                            <span
                              style={{ fontSize: "0.90rem", fontWeight: 400 }}
                            >
                              Select Horizontal/Vertical
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                        </InputLabel>
                        <Select
                          name="horVertical"
                          variant="filled"
                          value={
                            formData.horVertical
                              ? JSON.stringify(formData.horVertical)
                              : ""
                          }
                          onChange={handleChange}
                        >
                          {dropdownData.horVerticalList?.map((item) => (
                            <MenuItem
                              key={item.id}
                              value={JSON.stringify(item)}
                            >
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}

                  {(formData.dbseriesName?.dbSeriesName == "8GB30" ||
                    formData.dbseriesName?.dbSeriesName == "8GB32") && (
                    <FormControl size="small" sx={commonInputStyle}>
                      <InputLabel>
                        {
                          <span
                            style={{ fontSize: "0.90rem", fontWeight: 400 }}
                          >
                            Variant<span style={{ color: "red" }}>*</span>
                          </span>
                        }
                      </InputLabel>
                      <Select
                        name="varient"
                        variant="filled"
                        value={
                          formData.varient
                            ? JSON.stringify(formData.varient)
                            : ""
                        }
                        onChange={handleChange}
                      >
                        {dropdownData.varientList?.map((item) => (
                          <MenuItem
                            key={item.variantId}
                            value={JSON.stringify(item)}
                          >
                            {item.variantName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}

                  {isdbSelected && (
                    <>
                      <FormControl size="small" sx={commonInputStyle}>
                        <InputLabel>
                          {
                            <span
                              style={{ fontSize: "0.90rem", fontWeight: 400 }}
                            >
                              Country of Origin
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                        </InputLabel>
                        <Select
                          variant="filled"
                          name="contryOfOrigin"
                          value={
                            formData.contryOfOrigin
                              ? JSON.stringify(formData.contryOfOrigin)
                              : ""
                          }
                          onChange={handleChange}
                        >
                          {dropdownData.countryList?.map((item) => (
                            <MenuItem
                              key={item.countryId}
                              value={JSON.stringify(item)}
                            >
                              {item.countryName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <FormControl size="small" sx={commonInputStyle}>
                        <InputLabel>
                          {
                            <span
                              style={{ fontSize: "0.90rem", fontWeight: 400 }}
                            >
                              No. of Ways<span style={{ color: "red" }}>*</span>
                            </span>
                          }
                        </InputLabel>
                        <Select
                          variant="filled"
                          name="noOfWays"
                          value={
                            formData.noOfWays
                              ? JSON.stringify(formData.noOfWays)
                              : ""
                          }
                          onChange={handleChange}
                        >
                          {dropdownData.noWaysList?.map((item) => (
                            <MenuItem
                              key={item.noOfWaysId}
                              value={JSON.stringify(item)}
                            >
                              {item.noOfWaysName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>{" "}
                    </>
                  )}
                </Box>
                </div>

                <div  style={{
                    marginTop: "20px",
                    pointerEvents: editQuotation.editQuotation
                      ? "none"
                      : "auto",
                    opacity: editQuotation.editQuotation ? 0.5 : 1,
                  }}>
                  <Box
                    sx={{
                      border: "1px solid #ccc",
                      padding: "10px",
                      borderRadius: "4px",
                    }}
                  >
                    <Typography variant="subtitle1">
                      {
                        <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                          DB Price/MFLB Details
                        </span>
                      }
                    </Typography>
                    <TextField
                      variant="filled"
                      fullWidth
                      label={
                        <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                          MLFB
                        </span>
                      }
                      name="MLFBName"
                      value={formData.MLFBName}
                      readOnly
                      sx={commonInputStyle}
                    />

                    <TextField
                      fullWidth
                      variant="filled"
                      label={
                        <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                          Base mrp
                        </span>
                      }
                      name="mrp"
                      value={formData.mrp}
                      readOnly
                      sx={commonInputStyle}
                    />

                    <TextField
                      fullWidth
                      variant="filled"
                      label={
                        <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                          Unit MRP (incl. Z-options)
                        </span>
                      }
                      name="UnitNetPrice"
                      value={formData.UnitNetPrice}
                      readOnly
                      sx={commonInputStyle}
                    />

                    <TextField
                      fullWidth
                      variant="filled"
                      label={
                        <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                          Quntity
                        </span>
                      }
                      name="Quantity"
                      value={formData.Quantity}
                      onChange={handleChange}
                      type="number"
                      sx={commonInputStyle}
                    />

                    <TextField
                      fullWidth
                      variant="filled"
                      label={
                        <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                          Please note the Z options
                        </span>
                      }
                      name="zopt"
                      value={formData.zopt}
                      readOnly
                      sx={commonInputStyle}
                    />

                    <TextField
                      fullWidth
                      variant="filled"
                      label={
                        <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                          Total MRP
                        </span>
                      }
                      name="totalNetPrice"
                      value={formData.totalNetPrice}
                      readOnly
                      sx={commonInputStyle}
                    />
                  </Box>
                </div>
                <div style={{ marginTop: "20px" }}>
                  <Box
                    sx={{
                      border: "1px solid #ccc",
                      padding: "10px",
                      borderRadius: "4px",
                    }}
                  >
                    <Typography variant="subtitle1">
                      {
                       
                          <span
                            style={{ fontSize: "0.90rem", fontWeight: 400 }}
                          >
                            MLFB Drawing
                          </span>
                        
                      }
                    </Typography>
                    <Box
                      sx={{
                        height: "100px",
                        backgroundColor: "#d0d0d0",
                        textAlign: "center",
                        padding: "10px",
                      }}
                    >
                      <span
                        onClick={viewDrawing}
                        style={{
                          color: "darkblue",
                          fontWeight: "bold",
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                      >
                        View Drawing
                      </span>
                    </Box>
                  </Box>
                </div>

                <div style={{
                    marginTop: "20px",
                    pointerEvents: editQuotation.editQuotation
                      ? "none"
                      : "auto",
                    opacity: editQuotation.editQuotation ? 0.5 : 1,
                  }}>
                  <Box
                    sx={{
                      border: "1px solid #ccc",
                      padding: "10px",
                      borderRadius: "4px",
                    }}
                  >
                    <Typography variant="subtitle1">comment</Typography>

                    <TextField
                      fullWidth
                      variant="filled"
                      label={
                        <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                          comment
                        </span>
                      }
                      multiline
                      rows={3}
                      name="comment"
                      value={formData.comment}
                      onChange={handleChange}
                      // sx={commonInputStyle}
                    />
                  </Box>
                </div>
              </Box>

              <Box flex={1}>
                <div
                  style={{
                    marginTop: "20px",
                    pointerEvents: editQuotation.editQuotation
                      ? "none"
                      : "auto",
                    opacity: editQuotation.editQuotation ? 0.5 : 1,
                  }}
                >
                  <Box
                    sx={{
                      border: "1px solid #ccc",
                      padding: "10px",
                      borderRadius: "4px",
                    }}
                  >
                    <TextField
                      fullWidth
                      variant="filled"
                      label={
                        <span style={{ fontSize: "0.75rem", fontWeight: 400 }}>
                          Enter MLFB and quantity as CSV and enter; after
                          quantity. Eg : 8GB32205RC12,2;
                        </span>
                      }
                      multiline
                      rows={5}
                      name="bulk"
                      value={formData.bulk}
                      onChange={handleChange}
                      sx={commonInputStyle}
                    />
                  </Box>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "end",
                      padding: "10px",
                    }}
                  >
                    {/* <Button onClick={addBulk} className="btn">
                      AddBulk
                    </Button> */}
                  </div>
                </div>
                <div 
                  >
                  <Box
                    sx={{
                      border: "1px solid #ccc",
                      padding: "10px",
                      borderRadius: "4px",
                    }}
                  >
                    <Typography variant="subtitle1">
                      {
                        <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                          Non Standard Features
                        </span>
                      }
                    </Typography>
                    {features.map((feature, index) => (
                      <Accordion key={index} expanded={expanded === index}>
                        <AccordionSummary
                          expandIcon={
                            expanded === index ? <RemoveIcon /> : <AddIcon />
                          }
                          onClick={() => toggleAccordion(index)}
                        >
                          <Typography>{feature.name}</Typography>
                        </AccordionSummary>
                        <AccordionActions>
                          <div 
                           style={{
                            marginTop: "20px",
                            pointerEvents: editQuotation.editQuotation
                              ? "none"
                              : "auto",
                            opacity: editQuotation.editQuotation ? 0.5 : 1,
                          }}
                          >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 2,
                              width: "100%",
                            }}
                          >
                            {feature?.subcategories.map((item, index1) => {
                              const options = item.nonstandardFeature || [];
                              const isMultiselect =
                                item.selectionTypeValue == "multiple selection";
                              const selected = selectedFeatures.filter((code) =>
                                options.some((opt) => opt.zCode == code)
                              );
                              return (
                                <FormControl
                                  size="small"
                                  fullWidth
                                  sx={commonInputStyle}
                                  key={index1}
                                >
                                  <InputLabel>{item.name}</InputLabel>

                                  {/* {!isMultiselect && ( */}
                                  <Select
                                    multiple={isMultiselect}
                                    variant="filled"
                                    value={
                                      isMultiselect
                                        ? selected
                                        : selected[0] || ""
                                    }
                                    onChange={(e) =>
                                      handleChangefeature(
                                        e,
                                        options,
                                        isMultiselect
                                      )
                                    }
                                    MenupProps={{
                                      disableAutoFocusItem: true,
                                      PaperProps: {
                                        onMouseDown: (e) => {
                                          e.stopPropagation();
                                        },
                                      },
                                    }}
                                    renderValue={(selected) =>
                                      Array.isArray(selected)
                                        ? selected
                                            .map((code) => {
                                              const name =
                                                options.find(
                                                  (o) => o.zCode == code
                                                )?.name || code;
                                              return name;
                                            })
                                            .join(", ")
                                        : options.find(
                                            (o) => o.zCode == selected
                                          )?.name || selected
                                    }
                                  >
                                    {item.nonstandardFeature.map((val) => (
                                      <MenuItem
                                        key={val.id}
                                        value={val.zCode}
                                        disableRipple
                                      >
                                        <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "100%",
                                          }}
                                        >
                                          {item.selectionTypeValue ==
                                            "multiple selection" && (
                                            <Checkbox
                                              checked={selectedFeatures.includes(
                                                val.zCode
                                              )}
                                            />
                                          )}

                                          <ListItemText primary={val.name} />

                                          {isMultiselect &&
                                            val.zCode == "A61" && (
                                              <TextField
                                                variant="filled"
                                                size="small"
                                                name="NoOfKnockout_Bottom"
                                                sx={{ ml: 2, width: "100px" }}
                                                value={
                                                  formData.NoOfKnockout_Bottom
                                                }
                                                onClick={(e) =>
                                                  e.stopPropagation()
                                                }
                                                onChange={handleChange}
                                              />
                                            )}

                                          {isMultiselect &&
                                            val.zCode == "A60" && (
                                              <TextField
                                                variant="filled"
                                                size="small"
                                                name="NoOfKnockout"
                                                sx={{ ml: 2, width: "100px" }}
                                                value={formData.NoOfKnockout}
                                                onClick={(e) =>
                                                  e.stopPropagation()
                                                }
                                                onChange={handleChange}
                                              />
                                            )}
                                        </Box>
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              );
                            })}
                          </Box>
                          </div>
                        </AccordionActions>
                      </Accordion>
                    ))}
                  </Box>
                </div>
              </Box>
            </Stack>
          )}

          {/* <Tooltip title="Download excel"> */}
            <IconButton size="small" onClick={exportToExcel}>
              <DownloadIcon />
            </IconButton>
          {/* </Tooltip> */}

          <div style={{ height: 300, width: "100%" }}>
            <DataGrid
              rows={rows}
              columns={columns}
              pageSizeOptions={[10, 15, 20]}
              initialState={{
                pagination: { paginationModel: { pageSize: 10 } },
              }}
              getRowId={(row) => row.id}
              //loading={loader}
              disableRowSelectionOnClick
              localeText={{
                noRowsLabel: "No Matching Records Found!",
              }}
              sx={{
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#d3d3d3",
                  fontWeight: "500",
                  fontSize: "13px",
                  color: "black",
                  lineHeight: "1.5rem",
                },
                "& .MuiDataGrid-columnHeader": { backgroundColor: "#d3d3d3" },

                "& .MuiDataGrid-cell": { textAlign: "left", fontSize: "12px" },
                "& .MuiDataGrid-footerContainer": {
                  border: "1px solid #000",
                  fontSize: "12px",
                },
                "& .MuiDataGrid-virtualScroller": {
                  scrollbarWidth: "none",
                  "& ::-webkit-scrollbar": { display: "none" },
                },
              }}
            />

            <>
              <SnackbarCustom
                open={opend}
                message={snackMessage}
                alertType={alertType}
                handleClose={handleClose}
              />
            </>
          </div>
        </DialogContent>

        {/* <DialogActions>
        <Button onClick={handleSubmit} color="primary">
          Submit
        </Button>
      </DialogActions> */}
        {/* <Button
                        className="btn"
                        onClick={handleDrawing}
                        variant="contained"
                        color="primary"
                        sx={{ width: "120px", ml: 2 }}
                      >
                        Upload Drawing
                      </Button> */}

        <UploadDrawingDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          onUpload={onUploadDrawing}
        />
        {/* <>
                      <SnackbarCustom
                        open={opened}
                        message={snackMessage}
                        alertType={alertType}
                        handleClose={handleClose}
                      />
                    </> */}
      </Dialog>
      {/* {loaderUploading ? <Loading /> : <></>} */}
       {loader ? <Loading loaderText="Loading...!" /> : <></>}
    </div>
  );
});

export default UpdateUploadDrawing;
